// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2kBot","errorLogs":"EditorFooter_errorLogs__2In1-"};